import { IS_DEV, IS_QA } from "@/config/constants";
import useUserStore from "@/store/useUserStore";
import { roundNumber } from "./number";

const BGN_RATE = 1.96; // Bulgarian Lev to Euro conversion rate

export type DualPrice = Array<{ currency: string; value: number }>;

/**
 * Formats price with dual pricing for Bulgarian market
 * @param packPrice - Object containing country, currency, and value
 * @returns Formatted price string with HTML markup for dual pricing, or undefined
 */
export const getDualPrice = (currency: string, value: number): DualPrice => {
	const country = useUserStore().country;

	if (country.toLowerCase() === "bg") {
		const currentDate = new Date();
		const BGR_DATE_EXPIRATION = new Date("2026-08-08");
		const BGR_DATE_START =
			IS_DEV || IS_QA ? new Date("2025-01-01") : new Date("2026-01-01");

		if (currentDate < BGR_DATE_START) {
			return [{ currency, value }];
		}

		if (
			currency.toLowerCase() !== "bgn" &&
			currentDate <= BGR_DATE_EXPIRATION
		) {
			const lev = roundNumber(value * BGN_RATE * 100) / 100;
			return [
				{ currency: "EUR", value },
				{ currency: "BGN", value: lev },
			];
		}

		if (currency.toLowerCase() === "bgn") {
			const eur = roundNumber((value / BGN_RATE) * 100) / 100;
			return [
				{ currency: "EUR", value: eur },
				{ currency: "BGN", value },
			];
		}
	}

	return [{ currency, value }];
};
